import { Component, OnInit, Input, SecurityContext } from '@angular/core';
import { TicketAirType } from "@afidium/ts-facade";
import { Yii } from 'libraries/interfaces/Yii';
import { wenji } from "libraries/interfaces/IWenji";
import { Router } from "@angular/router";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

class Wording {
    public ticket: string = Yii.t('wui-sasha-js', 'Billet');
    public booking: string = Yii.t('wui-sasha-js', 'Dossier');
    public emission: string = Yii.t('wui-sasha-js', 'Émission :');
    public begin: string = Yii.t('wui-sasha-js', 'Départ :');
    public up: string = Yii.t('wui-sasha-js', 'UP :');
    public totalPrice: string = Yii.t('wui-sasha-js', 'Prix total :');
    public base: string = Yii.t('wui-sasha-js', 'Base :');
    public taxes: string = Yii.t('wui-sasha-js', 'Taxes :');
    public commission: string = Yii.t('wui-sasha-js', 'Commission :');
    public adjustment: string = Yii.t('wui-sasha-js', 'Surcoût :');
    public fop: string = Yii.t('wui-sasha-js', 'FOP :');
    public traveller: string = Yii.t('wui-sasha-js', 'Voyageur :');
    public system: string = Yii.t('wui-sasha-js', 'Système :');
    public agency: string = Yii.t('wui-sasha-js', 'Agence :');
    public agent: string = Yii.t('wui-sasha-js', 'Agent :');
    public vendor: string = Yii.t('wui-sasha-js', 'Compagnie :');
    public emittedExchange: string = Yii.t('wui-sasha-js', 'Emis en échange du billet :');
    public emittedExchanged: string = Yii.t('wui-sasha-js', 'Remplacé par le billet :');
    public creation: string = Yii.t('wui-sasha-js', 'Création :');
    public departure: string = Yii.t('wui-sasha-js', 'Départ :');
    public holder: string = Yii.t('wui-sasha-js', 'Titulaire :');
    public createdOn: string = Yii.t('wui-sasha-js', 'Créé le :');
}

@Component({
    selector: 'ticketing-detail',
    template: `
        <div class="cols">
            <div class="col half">
                <h3>{{wording.ticket}}
                    <a [routerLink]="bookingLink" fragment="travellers">{{ticket.number}}</a>
                    <ng-container *ngIf="!ticket.booking">
                        {{ticket.number}}
                    </ng-container>
                </h3>

                <div class="col-content">
                    <div class="cols sep-top">
                        <div class="col third" *ngIf="ticket.whenIssued?.date">{{wording.emission}}
                            <strong>{{ticket.whenIssued?.date | date:dateFormat}}</strong></div>
                        <div class="col third" *ngIf="ticket.begin?.date">{{wording.begin}}
                            <strong>{{ticket.begin?.date | date:dateFormat}}</strong></div>
                        <div class="col third"
                             *ngIf="ticket.sectorsCredited || ticket.sectorsCredited === 0">{{wording.up}}
                            <strong>{{ticket.sectorsCredited}}</strong></div>
                    </div>
                    <div class="cols sep-top" *ngIf="ticket.price">
                        <div class="col third" *ngIf="ticket.price | extractPrice">{{wording.totalPrice}}
                            <price-real-amount [value]="(ticket.price | extractPrice).amount"
                                               [showZero]="true"
                                               [currency]="(ticket.price | extractPrice).currency"></price-real-amount>
                        </div>
                        <div class="col third" *ngIf="ticket.price | extractPriceBase">{{wording.base}}
                            <price-real-amount [value]="(ticket.price | extractPriceBase).amount"
                                               [showZero]="true"
                                               [currency]="(ticket.price | extractPriceBase).currency"></price-real-amount>
                        </div>
                        <div class="col third" *ngIf="ticket.price | extractPriceTaxes">{{wording.taxes}}
                            <price-real-amount [value]="(ticket.price | extractPriceTaxes).amount"
                                               [showZero]="true"
                                               [currency]="(ticket.price | extractPriceTaxes).currency"></price-real-amount>
                        </div>
                    </div>
                    <div class="cols sep-top" *ngIf="ticket.price?.cost?.commission || ticket.price?.cost?.adjustment">
                        <div class="col third" *ngIf="ticket.price.cost?.commission">{{wording.commission}}
                            <price-real-amount
                                    [value]="(ticket.price | extractPriceCommissionAdjustment: 'commission').amount"
                                    [showZero]="true"
                                    [currency]="(ticket.price | extractPriceCommissionAdjustment: 'commission').currency"></price-real-amount>
                        </div>
                        <div class="col third" *ngIf="ticket.price.cost?.adjustment">{{wording.adjustment}}
                            <price-real-amount
                                    [value]="(ticket.price | extractPriceCommissionAdjustment: 'adjustment').amount"
                                    [showZero]="true"
                                    [currency]="(ticket.price | extractPriceCommissionAdjustment: 'adjustment').currency"></price-real-amount>
                        </div>
                        <div class="col third">

                        </div>
                    </div>
                    <div class="sep-top" *ngIf="ticket.payment | extractFop">
                        {{wording.fop}} <strong>{{ticket.payment | extractFop}}</strong>
                    </div>
                    <div class="sep-top" *ngIf="ticket.traveller">
                        {{wording.traveller}} <strong>{{ticket.traveller?.name}}</strong>
                    </div>
                    <div class="sep-top" *ngIf="ticket.host">
                        {{wording.system}} <strong>{{ticket.host?.code | hostAlias | async}}</strong>
                    </div>
                    <div class="sep-top" *ngIf="ticket.agency">
                        {{wording.agency}}
                        <strong>{{ticket.agency?.code}}
                            <ng-container *ngIf="ticket.agency?.iata">(IATA: {{ticket.agency?.iata}})</ng-container>
                        </strong>
                    </div>
                    <div class="sep-top" *ngIf="ticket.vendor">
                        {{wording.vendor}} <strong>{{ticket.vendor?.iata}}/{{ticket.vendor?.number}}</strong>
                    </div>
                    <ng-container *ngFor="let ticketItem of ticket.ticketArray">
                        <div class="sep-top" *ngIf="ticketItem.xState === 'Exchanged'">
                            {{wording.emittedExchange}} <strong>{{ticketItem.number}}</strong>
                        </div>
                        <div class="sep-top" *ngIf="ticketItem.xState === 'Exchange'">
                            {{wording.emittedExchanged}} <strong>{{ticketItem.number}}</strong>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="col half" *ngIf="ticket.booking">
                <h3>{{wording.booking}}
                    <a [routerLink]="bookingLink">{{ticket.booking.code}}</a>
                </h3>
                <div class="col-content">
                    <div class="cols sep-top" *ngIf="ticket.booking?.whenCreated?.date || ticket.booking?.begin?.date">
                        <div class="col third" *ngIf="ticket.booking?.whenCreated?.date">{{wording.creation}}
                            <strong>{{ticket.booking?.whenCreated?.date | date:dateFormat}}</strong></div>
                        <div class="col third" *ngIf="ticket.booking?.begin?.date">{{wording.departure}}
                            <strong>{{ticket.booking?.begin?.date | date:dateFormat}}</strong></div>
                    </div>
                    <div class="cols sep-top"
                         *ngIf="ticket.booking?.owner?.agent?.name || ticket.booking?.owner?.agent?.code">
                        <div>{{wording.holder}}
                            <strong>{{(ticket.booking?.owner?.agent?.name || ticket.booking?.owner?.agent?.code)}}</strong>
                        </div>
                    </div>
                    <ng-container *ngIf="ticket.booking">
                        <div *ngFor="let externalBooking of ticket.booking.externalBookingArray"
                             class="sep-top">
                            {{wording.booking}} {{externalBooking.host.code | hostAlias | async}}
                            <ng-container *ngIf="externalBooking.code">: <strong>{{externalBooking.code}}</strong>
                            </ng-container>
                            <span *ngIf="externalBooking.whenCreated">, {{wording.createdOn}} {{externalBooking.whenCreated.date | date:dateFormat}}</span>
                        </div>
                        <custom-fields [customFieldArray]="ticket.booking.customFieldArray"></custom-fields>
                    </ng-container>

                </div>
            </div>
        </div>
    `,
    styles: [`
        .cols {
            display: flex;
        }

        .col {
            flex-grow: 1;
        }

        .half {
            width: 50%;
        }

        .third {
            width: calc(100% / 3);
        }

        .col-content {
            padding-left: .75rem;
        }
        a {
            color: #337ab7;
        }
        a:visited {
            color: indigo;
        }
    `]
})

export class TicketingDetailComponent implements OnInit {

    @Input()
    public ticket: TicketAirType;

    public readonly wording: Wording = new Wording();
    public readonly dateFormat: string = JSON.parse(wenji.ui.dateFormat).short;

    public bookingLink: string;

    constructor(
        private readonly router: Router,
    ) {
    }

    public ngOnInit(): void {
        if (this.ticket && this.ticket.booking) {
            this.bookingLink = `../../booking/${this.ticket.booking.code}`;
        }
    }

    public goToBooking(bookingId: string): void {
        this.router.navigate(['/sasha', 'booking', bookingId]);
    }

    public getLink(bookingId: string): string {
        return `../../booking/${bookingId}`;
    }

    public goToBookingTicket(bookingId: string): void {
        this.router.navigate(['/sasha', 'booking', bookingId, '#travellers']);
    }
}
